<template>
    <div class="form-submit-base">
        <div class="form-submit-base--wrap">
            <loader-btn class="form-submit-base--btn"
                    type="submit"
                    :btn-facets="btnFacets"
                    :is-loading="isLoading"
                    @click.native="onSubmit">
                <slot/>
            </loader-btn>
        </div>
        <slot name="messages"/>
    </div>
</template>

<script>
    import { mapFilters } from 'util/vue/map-filters';
    import { FORM_SUBMISSION_STATE } from 'util/vue/form';
    import LoaderBtn from 'framework/components/buttons/loader-btn/loader-btn';
    import { isMountedMixin, bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        components: {
            LoaderBtn,
        },
        mixins: [
            isMountedMixin,
            bemMixin('form-submit-base'),
        ],
        props: {
            submissionState: {
                type: String,
                required: true,
            },
            onFormSubmit: {
                type: Function,
                required: true,
            },
            btnFacets: {
                type: Array,
                default() {
                    return ['primary', 'medium'];
                },
            },
        },
        data() {
            return {
                isVerifying: false,
                isVerified: false,
                widgetId: null,
            };
        },
        computed: {
            isLoading() {
                return this.isVerifying || this.submissionState === FORM_SUBMISSION_STATE.SUBMITTING;
            },
        },
        methods: {
            ...mapFilters(['translate']),
            onSubmit(event) {
                event.preventDefault();
                event.stopPropagation();
                this.submitForm();
            },
            submitForm() {
                this.isVerifying = false;

                if (!this.isLoading) {
                    this.onFormSubmit();
                }
            },
        },
    };
</script>
